(() => {
    document.addEventListener('alpine:init', () => {
      // Linked Products variant switching
      Alpine.data('LinkedProducts', (type) => ({
        linkedProductsType: '',
        $section: null,
        $products: [],
        products: [],
        hasSpecs: false,
        init() {
          let am = this;
          am.linkedProductsType = type;
  
          document.addEventListener('init-LinkedProducts', (e) => {
            if (am.$section) return;
  
            am.$section = e.target;
            am.$products = [...am.$section.querySelectorAll('[data-linked-product]')];
  
            // init products on page load
            (async () => {
              let px_products = am.$products.map(($item) => {
                let handle = $item.dataset.linkedProduct;
                return fetch(`/products/${handle}.js`).then(res => res.json());
              });
  
              am.products = await Promise.all(px_products);
              am.UpdateLinkedProductUrls();
            })();
          });
          subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
            am.UpdateLinkedProductUrls(e.data.variant.options);
          });
        },
  
        UpdateLinkedProductUrls(current_values) {
          let am = this;
  
          if (!am.products.length) return;
  
          am.$products.forEach(($product) => {
            let handle = $product.dataset.linkedProduct;
            let product = am.products.find(p => p.handle == handle);
  
            if (!product) return;
  
            if (!current_values) {
              current_values = JSON.parse($product.dataset.current_values);
            }
  
            let optionIdsToMatch = [1, 2, 3];
            if (am.linkedProductsType) {
              // exclude option from matching
              optionIdsToMatch = optionIdsToMatch.filter((id) => product.options.map(opt => opt.name).indexOf(am.linkedProductsType) !== (id - 1));
              //console.log(optionIdsToMatch);
            }
  
            let valuesToMatch = optionIdsToMatch.map((id) => current_values[(id - 1)]);
  
            let matching_variant = product.variants.find((v) => {
              let v_options = optionIdsToMatch.map((id) => v[`option${id}`]).join('/');
              return v_options == valuesToMatch.join('/')
            });
            if (!matching_variant) return;
            $product.setAttribute('href', `/products/${handle}?variant=${matching_variant.id}`);
  
            // apply soldout class if not available
            const shapeLabel = $product.querySelector('label')
            if (shapeLabel) {
              shapeLabel.classList.toggle('disabled', !(matching_variant && matching_variant.available));
            }
          });
        }
      }));
    })
  })()


class SizeDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    const overlay = this.querySelector('#SizeDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
    
    // Add this to handle your close button class name
    const closeButton = this.querySelector('.size-drawer-button');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    
    // Upgrade all custom elements when drawer opens
    customElements.upgrade(this);
    
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.querySelector('.drawer__inner') || this;
        const focusElement = this.querySelector('.size-drawer-button') || this.querySelector('.drawer__inner');
        if (focusElement && typeof trapFocus === 'function') {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    if (this.activeElement && typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('size-drawer', SizeDrawer);
  
if (!customElements.get('size-chart-trigger')) {
  customElements.define(
    'size-chart-trigger',
    class SizeChartTrigger extends HTMLElement {
      constructor() {
        super();
        
        // Get the button inside the trigger element
        const button = this.querySelector('button');
        
        if (button) {
          // Add click event to trigger button
          button.addEventListener('click', (evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            
            // Try multiple ways to find the drawer
            let sizeDrawer = null;
            
            // First try to find it as a sibling
            if (this.parentNode) {
              sizeDrawer = this.parentNode.querySelector('size-drawer');
            }
            
            // If not found, try the whole document
            if (!sizeDrawer) {
              sizeDrawer = document.querySelector('size-drawer');
            }
            
            if (sizeDrawer) {
              console.log('Found size drawer, showing it');
              sizeDrawer.open(button);
            } else {
              console.error('Size drawer not found');
            }
          });
        }
      }
    }
  );
}

// Product Rebuy Similar Styles Custom Element
class ProductRebuySimilarStyles extends HTMLElement {
  
  // Connected callback - called when element is added to DOM
  connectedCallback() {
    // Async function to load and display similar products
    return (async () => {
      try {
        // Check if template exists before proceeding
        const template = this.querySelector("template");
        if (!template) {
          console.warn('❌ Rebuy template not found');
          return;
        }
        
        // Get data from API
        const data = await this.getData();
        
        // If data exists, create product cards
        if (data && data.data && data.data.length > 0) {
          data.data.forEach((product) => {
            if (product && product.id) {
              const productCard = this.createProductCardItem(product);
              if (productCard) {
                this.appendChild(productCard);
              }
            }
          });
        }
        
        // Mark as loaded
        this.setAttribute("loaded", true);
        console.log('✅ Rebuy component loaded successfully');
      } catch (error) {
        console.log("❌ Error loading rebuy component:", error);
      }
    })();
  }

  // Format price using theme's native approach
  formatPrice(price) {
    if (!price) return null;
    
    const priceInDollars = typeof price === 'string' ? parseFloat(price) : price;
    
    const formattedPrice = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
      minimumFractionDigits: 2
    }).format(priceInDollars); 
    
    return formattedPrice;
  }

  // Remove selected state from variant swatches
  deselectSwatches(element) {
    if (!element) return;
    element.querySelectorAll(".variant-swatch").forEach((swatch) => {
      return swatch.classList.remove("selected");
    });
  }

  // Generate product link with optional variant
  getProductLink(handle, variantId) {
    if (!handle) return '#';
    return `/products/${handle}${variantId ? `?variant=${variantId}` : ""}`;
  }

  // Update product links in card
  updateProductLink(cardElement, product, variantId) {
    if (!cardElement || !product) return;
    
    const self = this;
    cardElement.querySelectorAll("[data-product-link]").forEach((linkElement) => {
      linkElement.setAttribute("href", `${self.getProductLink(product.handle, variantId)}`);
    });
  }

  // Create individual product card item
  createProductCardItem(product) {
    if (!product || !product.variants || !product.variants.length) {
      console.warn('Invalid product data:', product);
      return null;
    }
    
    const self = this;
    
    // Find first variant with price
    const firstVariant = product.variants.find((variant) => {
      return variant && variant.price;
    });
    
    if (!firstVariant) {
      console.warn('No valid variant found for product:', product.title);
      return null;
    }
    
    // Check if template exists
    const template = this.querySelector("template");
    if (!template || !template.content || !template.content.firstElementChild) {
      console.warn('Template not found or invalid');
      return null;
    }
    
    // Create images dictionary for easy lookup
    const imagesDict = this.getImagesDictionary(product);
    
    // Clone template
    const cardElement = template.content.firstElementChild.cloneNode(true);
    
    // Set basic product info - with null checks
    const titleElement = cardElement.querySelector(".product-list-card__title");
    const priceElement = cardElement.querySelector(".product-list-card__price");
    
    if (titleElement) {
      titleElement.innerHTML = product.title || '';
    }
    if (priceElement) {
      priceElement.innerHTML = this.formatPrice(firstVariant.price) || '';
    }
    
    // Set up Dawn's modal-opener and button attributes properly
    const modalOpener = cardElement.querySelector("modal-opener");
    const button = cardElement.querySelector(".product-list-card__button");
    
    if (modalOpener && button) {
      // Set modal target
      modalOpener.setAttribute('data-modal', `#QuickAdd-rebuy-${product.id}`);
      
      // Set button attributes exactly like Dawn does
      button.setAttribute('data-product-url', this.getProductLink(product.handle, firstVariant.id));
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-labelledby', `quick-add-rebuy-${product.id}-submit title-rebuy-${product.id}`);
      button.id = `quick-add-rebuy-${product.id}-submit`;
    }
    
    // Create modal with proper structure AFTER everything else is ready
    setTimeout(() => {
      try {
        const modal = this.createDawnQuickAddModal(product);
        if (modal && document.body) {
          // Wrap modal in a shopify-section to prevent Dawn's closest() error
          const sectionWrapper = document.createElement('div');
          sectionWrapper.className = 'shopify-section';
          sectionWrapper.id = `shopify-section-rebuy-${product.id}`;
          sectionWrapper.appendChild(modal);
          
          document.body.appendChild(sectionWrapper);
        }
      } catch (error) {
        console.warn('Error creating modal:', error);
      }
    }, 500);
    
    // Update product links
    this.updateProductLink(cardElement, product);
    
    // Find and set product image
    if (product.images && product.images.length > 0) {
      const variantImage = product.images.find((image) => {
        return image && image.variant_ids && image.variant_ids.some((id) => {
          return id === firstVariant.id;
        });
      });
      const productImage = variantImage || product.image || product.images[0];
      
      if (productImage) {
        const imageElement = this.createProductCardImage(productImage);
        const imageContainer = cardElement.querySelector(".product-list-card__image");
        if (imageElement && imageContainer) {
          imageContainer.appendChild(imageElement);
        }
      }
    }
    
    // Create color variants data structure
    const colorVariants = product.variants.reduce((acc, variant) => {
      if (!variant || !variant.option1) return acc;
      return acc[variant.option1] ? acc : {
        ...acc,
        [variant.option1]: {
          option1: variant.option1,
          price: variant.price,
          compare_at_price: variant.compare_at_price,
          variantId: variant.id,
          image_id: variant.image_id
        }
      };
    }, {});
    
    // Get unique color variants (limit to 4)
    const uniqueVariants = Object.values(colorVariants);
    const displayVariants = uniqueVariants.slice(0, 4);
    
    // Create color swatches
    const swatchContainer = cardElement.querySelector(".product-list-card__color-swatches");
    if (swatchContainer) {
      displayVariants.forEach((variant, index) => {
        if (variant) {
          const swatch = self.createColorSwatch(variant, imagesDict, index, cardElement, product);
          if (swatch) {
            swatchContainer.appendChild(swatch);
          }
        }
      });
      
      // Add "extra colors" indicator if more than 4 variants
      const extraColorsCount = uniqueVariants.length - displayVariants.length;
      if (extraColorsCount > 0) {
        const extraColorsSpan = this.createExtraColorsSpan(extraColorsCount);
        if (extraColorsSpan) {
          swatchContainer.appendChild(extraColorsSpan);
        }
      }
    }
    
    return cardElement;
  }

  // Create product image element
  createProductCardImage(image) {
    if (!image || !image.src) return null;
    
    const imgElement = document.createElement("img");
    imgElement.src = image.src;
    if (image.alt) {
      imgElement.alt = image.alt;
    }
    if (image.width) {
      imgElement.width = image.width;
    }
    if (image.height) {
      imgElement.height = image.height;
    }
    return imgElement;
  }

  // Create color swatch with click handler
  createColorSwatch(variant, imagesDict, index, cardElement, product) {
    if (!variant || !imagesDict || !cardElement || !product) return null;
    
    const self = this;
    const swatchTemplate = this.querySelector("template#productSwatchTemplate");
    
    if (!swatchTemplate || !swatchTemplate.content || !swatchTemplate.content.firstElementChild) {
      console.warn('Swatch template not found');
      return null;
    }
    
    const swatchElement = swatchTemplate.content.firstElementChild.cloneNode(true);
    
    // Mark first swatch as selected
    if (index === 0) {
      swatchElement.classList.add("selected");
    }
    
    // Set swatch properties with null checks
    const labelElement = swatchElement.querySelector(".variant-swatch__label");
    if (labelElement) {
      labelElement.innerHTML = `${product.title}-${variant.option1}`;
    }
    
    // Check if image exists in dictionary
    const variantImage = imagesDict[variant.image_id];
    if (variantImage && variantImage.src) {
      swatchElement.setAttribute("data-image", variantImage.src);
      swatchElement.style.backgroundImage = `url(${variantImage.src})`;
      
      if (variantImage.alt) {
        swatchElement.setAttribute("data-image-alt", variantImage.alt);
      }
    }
    
    swatchElement.setAttribute("data-variant-id", variant.variantId);
    swatchElement.setAttribute("data-price", this.formatPrice(variant.price));
    
    if (variant.compare_at_price) {
      swatchElement.setAttribute("data-compare-at-price", this.formatPrice(variant.compare_at_price));
    }
    
    // Add click event listener
    swatchElement.addEventListener("click", () => {
      // Deselect other swatches
      self.deselectSwatches(cardElement);
      
      // Update card elements
      const priceElement = cardElement.querySelector(".product-list-card__price");
      const imageElement = cardElement.querySelector(".product-list-card__image img");
      const quickAddButton = cardElement.querySelector(".product-list-card__button");
      
      // Update product link with variant
      self.updateProductLink(cardElement, product, swatchElement.dataset.variantId);
      
      // Update quick add button's data-product-url to include variant
      if (quickAddButton) {
        const newProductUrl = self.getProductLink(product.handle, swatchElement.dataset.variantId);
        quickAddButton.setAttribute('data-product-url', newProductUrl);
      }
      
      // Update image
      if (imageElement && swatchElement.dataset.image) {
        imageElement.src = swatchElement.dataset.image;
        if (swatchElement.dataset.imageAlt) {
          imageElement.alt = swatchElement.dataset.imageAlt;
        }
      }
      
      // Update price
      if (priceElement) {
        const newPrice = swatchElement.dataset.compareAtPrice ? 
          swatchElement.dataset.compareAtPrice : 
          swatchElement.dataset.price;
        priceElement.innerHTML = newPrice;
      }
      
      // Mark swatch as selected
      swatchElement.classList.add("selected");
    });
    
    return swatchElement;
  }

  // Create extra colors indicator
  createExtraColorsSpan(count) {
    if (!count || count <= 0) return null;
    
    const spanElement = document.createElement("span");
    spanElement.innerText = `+${count}`;
    spanElement.classList.add("extra-colors-notice");
    return spanElement;
  }

  // Create Dawn-style quick add modal
  createDawnQuickAddModal(product) {
    if (!product || !product.id || !product.title) {
      console.warn('Invalid product data for modal creation');
      return null;
    }
    
    try {
      // Create the full HTML structure as a string first
      const modalHTML = `
        <quick-add-modal id="QuickAdd-rebuy-${product.id}" class="quick-add-modal">
          <div
            role="dialog"
            aria-label="Choose product options for ${product.title.replace(/"/g, '&quot;')}"
            aria-modal="true"
            class="quick-add-modal__content global-settings-popup"
            tabindex="-1"
          >
            <button
              id="ModalClose-rebuy-${product.id}"
              type="button"
              class="quick-add-modal__toggle"
              aria-label="Close"
            >
              <svg class="icon icon-close" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M17.25 1.78125L16.2188 0.75L9 7.96875L1.78125 0.75L0.75 1.78125L7.96875 9L0.75 16.2188L1.78125 17.25L9 10.0312L16.2188 17.25L17.25 16.2188L10.0312 9L17.25 1.78125Z" fill="currentColor"/>
              </svg>
            </button>
            <div id="QuickAddInfo-rebuy-${product.id}" class="quick-add-modal__content-info"></div>
          </div>
        </quick-add-modal>
      `;
      
      // Parse the HTML string into a DOM element
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = modalHTML;
      return tempDiv.firstElementChild;
    } catch (error) {
      console.warn('Error creating modal HTML:', error);
      return null;
    }
  }

  // Create images dictionary for easy lookup by ID
  getImagesDictionary(product) {
    if (!product || !product.images) return {};
    
    return product.images.reduce((acc, image) => {
      if (image && image.id) {
        return {
          ...acc,
          [image.id]: image
        };
      }
      return acc;
    }, {});
  }

  // Fetch product data from Rebuy API
  async getData() {
    try {
      const productId = this.dataset.productId;
      if (!productId) {
        console.warn('No product ID found');
        return null;
      }
      
      const apiUrl = "https://rebuyengine.com/api/v1/custom/id/185876";
      const rebuyApiKey = window.theme?.rebuyApiKey; // Uses your API key from theme settings
      
      if (!rebuyApiKey) {
        console.warn('Rebuy API key not found');
        return null;
      }
      
      const response = await fetch(`${apiUrl}?shopify_product_ids=${productId}&format=pretty&key=${rebuyApiKey}&limit=3`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.warn('Error fetching rebuy data:', error);
      return null;
    }
  }
}

// Register the custom element
customElements.define("product-rebuy-similar-styles", ProductRebuySimilarStyles);